'use client';

import { forwardRef } from 'react';
import { Button, type ButtonProps } from './Button';
import { LoadingSpinner } from './LoadingSpinner';

export interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean;
  loadingText?: string;
  spinnerPosition?: 'left' | 'right';
}

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  (
    {
      isLoading = false,
      loadingText,
      spinnerPosition = 'left',
      disabled,
      children,
      className,
      ...props
    },
    ref
  ) => {
    const isDisabled = disabled || isLoading;

    return (
      <Button ref={ref} disabled={isDisabled} className={className} {...props}>
        {isLoading ? (
          <span className="flex items-center justify-center">
            {spinnerPosition === 'left' && (
              <LoadingSpinner size="sm" className="me-2" />
            )}
            <span>{loadingText || children}</span>
            {spinnerPosition === 'right' && (
              <LoadingSpinner size="sm" className="ms-2" />
            )}
          </span>
        ) : (
          children
        )}
      </Button>
    );
  }
);

LoadingButton.displayName = 'LoadingButton';
